import React, { forwardRef } from 'react';
import { Icon } from 'rsuite';
import styles from './IPAGlobalAlert.module.scss';

type IPAGlobalAlertType = 'warning' | 'info' | 'error' | 'success';

type IPAGlobalAlertData = {
  active: boolean;
  type: IPAGlobalAlertType;
  title: string;
  description: string;
};

export type IPAGlobalAlertProps = {
  alert?: IPAGlobalAlertData;
} & React.HTMLAttributes<HTMLDivElement>;

const allowedIPAGlobalAlert = true;

// TODO: isso deve vir do backend e ser passado para esse componente via prop, vai ficar aqui apenas pq temos pressa.
const maintenanceAlert: IPAGlobalAlertData = {
  active: allowedIPAGlobalAlert,
  type: 'error',
  title: 'Manutenção agendada (19h–23h / 21/05)',
  description: 'Não realize alterações ou aplicações de preço durante esse período. Use o IPA somente para consulta.',
};

const ICONS = {
  warning: 'exclamation-triangle',
  info: 'info-circle',
  error: 'exclamation-circle',
  success: 'check-circle',
} as const;

export const IPAGlobalAlert = forwardRef<HTMLDivElement, IPAGlobalAlertProps>(({ alert = maintenanceAlert, className = '', ...props }, ref) => {
  if (!alert?.active) return null;

  return (
    <div className={[styles['ipa-global-alert'], styles[`ipa-global-alert--${alert.type}`], className].filter(Boolean).join(' ')} ref={ref} {...props}>
      <div className={styles['ipa-global-alert__message']}>
        <Icon icon={ICONS[alert.type]} className={styles['ipa-global-alert__icon']} />
        <p>
          <strong>{alert.title}</strong>
          <span> - {alert.description}</span>
        </p>
      </div>
    </div>
  );
});

IPAGlobalAlert.displayName = 'IPAGlobalAlert';
